import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';

import { getLabelMessage } from '@gef-ui/localization/messages';

import SectionHeader from 'components/atoms/GefMui/SectionHeader';

import PszpNoticeTable from './PszpNoticeTable';

export const TaskPszpNoticeModalBody = ({ taskId }) => (
	<Stack spacing={2}>
		<SectionHeader text={getLabelMessage('pszpNotice:resultsSubheader')} />
		<PszpNoticeTable taskId={taskId} />
	</Stack>
);

TaskPszpNoticeModalBody.propTypes = {
	taskId: PropTypes.number,
};

export default TaskPszpNoticeModalBody;
